import AuthLayout from '../../../components/AuthLayout';
import ForgetContainer from '../../../containers/Forget';

export default function Forget() {
  return (
    <AuthLayout maxWidth="xl" title="رابکس | فراموشی رمزعبور">
      <ForgetContainer />
    </AuthLayout>
  );
}
